import React from 'react';
import { Box } from '@mui/material';

import { embedYouTubeUrl } from './constants';
import { IMediaLoader } from './interfaces';

import YoutubeEmbed from './YoutubeEmbed';
import VideoPlayer from './VideoPlayer';

import { useStyles } from './style';
import { isVideo } from './helpers';

import DefaultBackground from '@public/images/ek/tempImagesBeforeTheyAreInAdmin/defaultDesktop.jpg';

const Media = ({ loadingAsset }: IMediaLoader) => {
  const classes = useStyles();

  if (!loadingAsset) {
    return <img src={DefaultBackground} />;
  }

  if (typeof loadingAsset === 'string') {
    const mediaId = loadingAsset.replace(embedYouTubeUrl, '');

    return <YoutubeEmbed embedId={mediaId} />;
  }

  if (isVideo(loadingAsset?.url)) {
    return (
      <VideoPlayer loop autoPlay controls={false} url={loadingAsset?.url} />
    );
  }

  return (
    <Box
      component="img"
      src={loadingAsset?.url}
      alt="Tip image"
      sx={classes.img}
    />
  );
};

export default Media;
